module.exports = __webpack_public_path__ + "img/Djibouti.0e440fff.gif";